export function globalAlert() {
    let mainElement = document.querySelector('#main') as HTMLElement;

    function adjustMainMarginTop() {
        if (document.querySelector('.adage-alert-global')) {
            if (window.innerWidth >= 1025) {
                let navElement = document.querySelector('.nav') as HTMLElement;
                let navUtility = document.querySelector('.nav-utility') as HTMLElement;
                let navMain = document.querySelector('.nav-main') as HTMLElement;
                let adageAlert = document.querySelector('.adage-alert-desktop') as HTMLElement;
                let navHeight = navUtility.offsetHeight + navMain.offsetHeight + adageAlert.offsetHeight;
                let mobileGlobalAlert = document.querySelector('.js-global-alert-mobile') as HTMLButtonElement;
                let mobileGlobalAlertExpanded = mobileGlobalAlert.getAttribute('aria-expanded');

                mainElement.style.marginTop = navHeight + 'px';
                navElement.style.maxHeight = navHeight + 'px';

                if (mobileGlobalAlertExpanded == "true") {
                    mobileGlobalAlert.click();
                }
            }
            else {
                let mobileNavElement = document.querySelector('.mobile-nav') as HTMLElement;
                let mobileNavHeight = mobileNavElement.offsetHeight;
                let desktopGlobalAlert = document.querySelector('.js-global-alert-desktop') as HTMLButtonElement;
                let desktopGlobalAlertExpanded = desktopGlobalAlert.getAttribute('aria-expanded');

                mainElement.style.marginTop = mobileNavHeight + 'px';

                if (desktopGlobalAlertExpanded == "true") {
                    desktopGlobalAlert.click();
                }
            }
        }
    }

    adjustMainMarginTop();

    window.addEventListener('resize', function () {
        adjustMainMarginTop();
    })
}